'use client';

import React__default from 'react';
import { ListProficiency, ProficiencyItem, CurrentItemBox } from './Proficiency.css.js';
import { ConvertHexToRgbA } from '../Utils/helpers.js';

/* eslint-disable no-unused-expressions */
var Proficiency = function (props) {
    var _a = props.options, options = _a === void 0 ? [] : _a, _b = props.onSelected, onSelected = _b === void 0 ? function () { } : _b, _c = props.value, value = _c === void 0 ? 1 : _c;
    if (options.length === 0)
        return null;
    var selected = options.find(function (item) { return item.id === value; });
    var currentIndex = options.findIndex(function (item) { return item.id === value; });
    return (React__default.createElement(ListProficiency, null,
        options.map(function (item, index) {
            return (React__default.createElement(ProficiencyItem, { key: index, onClick: function () { return onSelected(item.id); }, style: {
                    listLength: options.length,
                    backgroundSeparator: (selected === null || selected === void 0 ? void 0 : selected.bgColor) || 'transparent',
                    borderRadius: index === 0 || index === options.length - 1 ? '4px' : '0',
                    background: selected
                        ? ConvertHexToRgbA(selected.bgColor, '0.1')
                        : ConvertHexToRgbA(item.bgColor, '0.1'),
                    backgroundHover: selected
                        ? ConvertHexToRgbA(selected.bgColor, '0.3')
                        : ConvertHexToRgbA(item.bgColor, '1')
                } }));
        }),
        React__default.createElement(CurrentItemBox, { style: {
                listLength: options.length,
                background: (selected === null || selected === void 0 ? void 0 : selected.bgColor) || 'transparent',
                transform: "translateX(".concat(currentIndex || 0, "00%)")
            } })));
};

export { Proficiency as default };
//# sourceMappingURL=index.js.map
